import { Grid, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDBox from "../../Components/MDBox";
import MDButton from "../../Components/MDButton";
import MDDivider from "../../Components/MDDivider";
import MDInput from "../../Components/MDInput";
import MDTypography from "../../Components/MDTypography";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import { v4 as uuid } from "uuid";
import AddAsnaf from "./components/AddAsnaf";
import { AsnafCategoryModel } from "../../Api/Models/AsnafCategoryModel";
import { ErrorToaast, SuccessToaast } from "../../utils/toast/Toast";
import AddChild from "./components/AddChild";
import { SenfModel } from "../../Api/Models/SenfModel";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
export default function Asnaf() {
  const [categorySelect, setCategorySelect] = useState<null | string>(null);
  const [categories, setCategories] = useState([]);
  const [open, setOpen] = useState(false);
  const [childOpen, setChildOpen] = useState(false);
  const [counter, setCounter] = useState(1);
  const [salMali, setSalMali] = useState("1401");
  const asnafCategory = new AsnafCategoryModel();
  const [senfDetail, setSenfDetail] = useState<any>(null);
  const senfModel = new SenfModel();
  useEffect(() => {
    asnafCategory.getAll().then((r) => {
      setCategories(r.data.data);
      setCategorySelect(r.data.data[0].id);
    });
    return () => {};
  }, [counter]);
  const handleSearch = () => {
    asnafCategory
      .get(parseInt(categorySelect ?? "1"))
      .then((result: any) => {
        setSenfDetail(result.data.data);
      })
      .catch((err) => ErrorToaast("با مشکل مواجه شد"));
  };
  const handleAddChild = (data: any) => {
    var send = {
      Title: data.Title,
      Description: data.Description,
      Gheymat: data.Gheymat,
      AsnafCategoryId: categorySelect,
    };
    senfModel
      .crete(send)
      .then(async (result) => {
        SuccessToaast("با موفقت افزوده شد");
        await setChildOpen(false);
        await handleSearch();
      })
      .catch((err) => ErrorToaast("مشکل در برقراری ارتباط"));
  };
  return (
    <DashboardLayout>
      <DashboardNavbar name={"اصناف"} />
      <MDBox bgColor="white" borderRadius="5px" p={"10px"}>
        <MDTypography fontSize={"15px"} fontWeight="bold">
          جستجوی صنف
        </MDTypography>
        <MDDivider />
        <Grid container mt={2}>
          <Grid container item>
            <Grid item xs={2} textAlign="center" alignSelf={"center"}>
              <MDTypography fontSize={"15px"}>انتخاب دسته </MDTypography>
            </Grid>
            <Grid item xs={4} textAlign="center">
              {categorySelect && (
                <Select fullWidth size="small" value={categorySelect} onChange={(e) => setCategorySelect(e.target.value)}>
                  {categories.length > 0 &&
                    categories.map((r: any) => {
                      return (
                        <MenuItem value={r.id} key={uuid()}>
                          {r.title}
                        </MenuItem>
                      );
                    })}
                </Select>
              )}
            </Grid>
            <Grid item xs={2} textAlign="center" alignSelf={"center"}>
              <MDTypography fontSize={"15px"}>سال مالی</MDTypography>
            </Grid>
            <Grid item xs={4} textAlign="center">
              <Select fullWidth size="small" value={salMali} onChange={(r) => setSalMali(r.target.value)}>
                {[1390, 1391, 1392, 1393, 1394, 1395, 1396, 1397, 1398, 1399, 1400, 1401].map((r) => (
                  <MenuItem value={r} key={uuid()}>
                    {r}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
          <Grid container item mt={2} mx={5} gap={"0px 10px"} wrap="nowrap">
            <Grid item xs={3}>
              <MDButton variant="outlined" fullWidth color="warning" onClick={handleSearch}>
                جستجو
              </MDButton>
            </Grid>
            <Grid item xs={3}>
              <MDButton variant="outlined" fullWidth color="success" onClick={() => setOpen(true)}>
                جدید
              </MDButton>
            </Grid>
            <Grid item xs={3}>
              <MDButton variant="outlined" fullWidth color="secondary">
                ویرایش
              </MDButton>
            </Grid>
            <Grid item xs={3}>
              <MDButton variant="outlined" fullWidth color="error">
                حذف
              </MDButton>
            </Grid>
            <Grid item xs={3}>
              <MDButton
                variant="outlined"
                fullWidth
                color="primary"
                onClick={() => {
                  setChildOpen(true);
                }}
              >
                افزدون زیر شاخه
              </MDButton>
            </Grid>
          </Grid>
          <Grid container item>
            <Grid item xs={12} mt={2}>
              <MDTypography fontSize="14px" fontWeight="bold">
                لیست اصناف
              </MDTypography>
              <MDDivider />
            </Grid>
            <Grid item xs={12}>
              <MDBox minHeight="40vh" maxHeight="40vh" sx={{ overflow: "auto" }} bgColor="#adaabb" mt={1} border="2px #5b5b5b solid">
                <MDBox bgColor="#eeeeee" px={1}>
                  <Grid container columns={6} textAlign="center">
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>شاخه اصلی</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>زیر شاخه</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>سال مالی</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>ضریب مصوب</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>ویرایش</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>حذف</MDTypography>
                    </Grid>
                  </Grid>
                </MDBox>
                {senfDetail?.senfs.length > 0 ? (
                  senfDetail.senfs.map((data: any, index: number) => {
                    return (
                      <MDBox
                        bgColor={index % 2 === 0 ? "#fbfbfb" : "white"}
                        px={1}
                        key={uuid()}
                        sx={{ ":hover": { background: "#9185c8" }, cursor: "pointer" }}
                      >
                        <Grid container textAlign={"center"}>
                          <Grid item xs={2}>
                            <MDTypography fontSize={"14px"}>{senfDetail.title}</MDTypography>
                          </Grid>
                          <Grid item xs={2}>
                            <MDTypography fontSize={"14px"}>{data.title}</MDTypography>
                          </Grid>
                          <Grid item xs={2}>
                            <MDTypography fontSize={"14px"}>{senfDetail.salMali}</MDTypography>
                          </Grid>
                          <Grid item xs={2}>
                            <MDTypography fontSize={"14px"}>{data.gheymat}</MDTypography>
                          </Grid>
                          <Grid item xs={2}>
                            <MDBox onClick={() => {}}>
                              <EditIcon color="info" />
                            </MDBox>
                          </Grid>
                          <Grid item xs={2}>
                            <MDBox onClick={() => {}}>
                              <DeleteIcon color="error" />
                            </MDBox>
                          </Grid>
                        </Grid>
                      </MDBox>
                    );
                  })
                ) : (
                  <MDBox bgColor={"#fbfbfb"} px={1} sx={{ ":hover": { background: "#9185c8" }, cursor: "pointer" }} textAlign="center" py={2}>
                    <MDTypography fontSize="16px"> هیچ زیر شاخه ای وجود ندارد</MDTypography>
                  </MDBox>
                )}
              </MDBox>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <AddAsnaf
        open={open}
        setClose={() => setOpen(false)}
        onDone={() => {
          setOpen(false);
          setCounter((c) => c + 1);
        }}
      />
      <AddChild
        open={childOpen}
        setClose={() => setChildOpen(false)}
        onDone={(e: any) => {
          handleAddChild(e);
        }}
      />
    </DashboardLayout>
  );
}
